import React from "react";
import Toprate from "../api/Toprate";
import MovieRow from "./MovieRow";

const TopRate = () => (
  <MovieRow title="Top Rated" seeAllPath="/toprated" fetcher={Toprate} />
);

export default TopRate;
